import React, { ChangeEventHandler, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import Label from '@components/dataEntry/Input/Label';
import { DayPicker } from 'react-day-picker';
import { isValid, parse } from 'date-fns';
import DropdownWrapper, {
  dropdownDirMap,
} from '@components/wrapper/DropdownWrapper';
import TextInput from '@components/dataEntry/Input/TextInput';

import dayjs from 'dayjs';
import Button from '@components/dataEntry/button/Button';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const DayPickerWrapper = styled.div`
  .rdp {
    margin: 0 !important;
  }
`;

export interface DateInputProps {
  placeholder?: string;
  label?: string;
  required?: boolean;
  onKeyPress?: React.KeyboardEventHandler<HTMLInputElement> | undefined;
  min?: number;
  max?: number;
  width?: number | string;
  initialDate?: Date;
  initidalDays?: any[];
  date?: Date | undefined | null;
  setDate: any;
  multiple?: {
    min: number;
    max: number;
  };
  mode?: 'multiple' | 'single' | 'range';
  dropdownDir?: keyof typeof dropdownDirMap;
  style?: any;
  [propName: string]: any;
}

function DateInput({
  label,
  required,
  mode = 'single',
  width,
  placeholder,
  setDate,
  date,
  dropdownDir,
  style,
}: DateInputProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const pickerRef = useRef<HTMLDivElement>(null);

  // const [selected, setSelected] = useState<Date | undefined | null>(date);
  const [inputValue, setInputValue] = useState<string>('');

  function handleDaySelect(date: Date) {
    if (date) {
      // setSelected(date);
      setDate(date);
      setInputValue(dayjs(date).format('YYYY-MM-DD'));
    } else {
      setInputValue('');
      setDate('');
    }
  }

  const handleInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const targetValue = e.currentTarget.value;
    setInputValue(targetValue);

    const date = parse(e.currentTarget.value, 'y-MM-dd', new Date());
    if (isValid(date)) {
      // setSelected(date);
      setDate(date);
    } else {
      // setSelected(undefined);
      setDate('');
    }
  };

  useEffect(() => {
    if (date) {
      setInputValue(dayjs(date).format('YYYY-MM-DD'));
    }
  }, [date]);

  // datePicker 바깥 쪽 눌렀을 때 -------------------------------------------
  function handleClickOutside(e, dropdownNode) {
    if (pickerRef.current && dropdownNode) {
      if (
        !pickerRef.current.contains(e.target) &&
        !dropdownNode.contains(e.target) &&
        isOpen
      )
        setIsOpen(false);
    }
  }
  // datePicker 바깥 쪽 눌렀을 때 end -------------------------------------------
  function handleFocus() {
    setIsOpen(true);
  }

  return (
    <>
      <Wrapper style={style}>
        {label && <Label required={required}>{label}</Label>}
        <div ref={pickerRef} style={{ width: '100%' }}>
          <TextInput
            value={inputValue}
            name="from date"
            onChange={handleInputChange}
            placeholder={placeholder || '날짜 선택'}
            onFocus={handleFocus}
          />
        </div>

        {isOpen && (
          <DropdownWrapper
            handleClickOutside={handleClickOutside}
            direction={dropdownDir || 'bottomLeft'}
            style={{ width: 'fit-content' }}
            open={isOpen}
          >
            <DayPickerWrapper>
              <div style={{ position: 'relative', display: 'inline-block' }}>
                {/* 오늘 버튼을 DayPicker 상단 우측에 절대 배치 */}
                <Button
                  size="sm"
                  onClick={() => {
                    const today = new Date();
                    setDate(today);
                  }}
                  style={{
                    position: 'absolute',
                    top: 8,
                    right: 80,
                    zIndex: 2,
                  }}
                >
                  Today
                </Button>
                <DayPicker
                  initialFocus={isOpen}
                  mode="single"
                  style={{ width: '100%' }}
                  defaultMonth={date!}
                  selected={date!}
                  onSelect={handleDaySelect}
                />
              </div>
            </DayPickerWrapper>
          </DropdownWrapper>
        )}
      </Wrapper>
    </>
  );
}

export default React.memo(DateInput);
